import { CartItem } from '@/types/Cart';

const SELECTED_PACK_KEY = 'selectedPack';

export const BUILD_YOUR_PACK_ITEM_CODE = '2840';
export const BASIC_START_KIT_ITEM_CODE = '2880';

export type SelectedPackType = 'basic' | 'build' | null;

export const getSelectedPack = (): SelectedPackType => {
  if (typeof window === 'undefined') return null;
  try {
    const pack = localStorage.getItem(SELECTED_PACK_KEY);
    return (pack as SelectedPackType) || null;
  } catch {
    return null;
  }
};

export const setSelectedPack = (pack: SelectedPackType): void => {
  if (typeof window === 'undefined') return;
  try {
    if (pack) {
      localStorage.setItem(SELECTED_PACK_KEY, pack);
    } else {
      localStorage.removeItem(SELECTED_PACK_KEY);
    }
  } catch {
    // Error handled silently
  }
};

export const clearEnrollmentTracking = (): void => {
  setSelectedPack(null);
};

export const isEnrollmentRoute = (pathname: string): boolean => {
  return pathname.includes('/enrollment');
};

export const isEnrollmentFlowRoute = (pathname: string): boolean => {
  return pathname.includes('/enrollment') || pathname.includes('/cart');
};

export const isEnrollmentPackCode = (itemCode: string): boolean => {
  return itemCode === BUILD_YOUR_PACK_ITEM_CODE || itemCode === BASIC_START_KIT_ITEM_CODE;
};

export const isBasicStartPackCode = (itemCode: string): boolean => {
  return itemCode === BASIC_START_KIT_ITEM_CODE;
};

export const isBuildYourPackCode = (itemCode: string): boolean => {
  return itemCode === BUILD_YOUR_PACK_ITEM_CODE;
};

export const findEnrollmentPackItemsInCart = (cart: CartItem[]): Array<{ itemId: string; itemCode: string }> => {
  if (!cart || cart.length === 0) return [];

  return cart
    .filter(item => {
      const code = String(item.itemCode || item.id);
      return isEnrollmentPackCode(code);
    })
    .map(item => ({
      itemId: item.itemId,
      itemCode: String(item.itemCode || item.id),
    }));
};

export const getPackItemCode = (packType: SelectedPackType): string | null => {
  if (packType === 'build') return BUILD_YOUR_PACK_ITEM_CODE;
  if (packType === 'basic') return BASIC_START_KIT_ITEM_CODE;
  return null;
};
